import { Routes } from '@angular/router';
import { LeagueHomeComponent } from './league-home.component';
import { LeagueHomeResolver } from './league-home.resolver';
import { DialogPageComponent } from '@mtgame/ui';
import { PhotoDetailComponent } from './league-photos/photo-detail.component';

export const ROUTES: Routes = [
  {
    path: '',
    component: LeagueHomeComponent,
    resolve: {
      data: LeagueHomeResolver
    },
    children: [
      {
        path: 'photo/:mediaId',
        component: DialogPageComponent,
        data: {
          config: {
            isCloseButtonVisible: true,
            fullScreen: true,
            closeLink: '/'
          },
          component: PhotoDetailComponent,
        }
      }
    ]
  }
];
